/* MANDATORY frame and environment data */
export default {
  frame: {},
  brand: 'rayban' /* MANDATORY to enable brand related UX customizations OPTIONAL otherwise */,
  lens: {},
}
